// src/pages/PostDetail/index.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Layout, Typography, Avatar, Space, Tag, Divider, FloatButton, Button } from 'antd';
import { UserOutlined, CalendarOutlined, PushpinOutlined, VerticalAlignTopOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import moment from 'moment';
import { getPostById } from '../../api/mockData'; // 使用数据获取函数
import './index.css';

const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

const PostDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 使用 getPostById 函数获取文章
    const foundPost = getPostById(id);
    
    if (foundPost) {
      setPost(foundPost);
    } else {
      // 如果没有找到文章，显示错误信息
      console.error(`未找到ID为 ${id} 的文章`);
    }
    
    setLoading(false);
  }, [id]);

  if (loading) {
    return <div className="loading-state">文物故事加载中...</div>;
  }

  if (!post) {
    return (
      <div className="not-found-container">
        <div className="not-found-content">
          <h2>文物故事未找到</h2>
          <p>抱歉，您寻找的文物故事可能已消失在历史长河中...</p>
          <Link to="/">
            <Button type="primary" icon={<ArrowLeftOutlined />}>
              返回首页
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <Content className="post-detail-content">
      <div className="post-detail-container">
        <div className="post-header">
          <Link to="/" className="back-link">
            <ArrowLeftOutlined /> 返回首页
          </Link>
          <Title level={1} className="post-detail-title">{post.title}</Title>
        </div>
        
        <Space size="large" className="post-meta">
          <Text>
            <UserOutlined /> 作者: 
            <Avatar 
              size="small" 
              src="https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg"
              style={{ marginLeft: 8 }}
            /> 
            {post.author}
          </Text>
          <Text>
            <CalendarOutlined /> 日期: {moment(post.date).format('YYYY年MM月DD日 HH:mm')}
          </Text>
          <Text>
            <PushpinOutlined /> 标签: 
            {post.tags && post.tags.map(tag => (
              <Tag key={tag} className="detail-tag">{tag}</Tag>
            ))}
          </Text>
        </Space>
        
        <Divider className="antique-divider" />
        
        <div className="post-summary-section">
          <Text strong>文物简介：</Text>
          <Paragraph className="post-summary">{post.summary}</Paragraph>
        </div>
        
        <Divider className="antique-divider" />
        
        <Paragraph className="markdown-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {post.content || '暂无详细内容'}
          </ReactMarkdown>
        </Paragraph>
      </div>
      <FloatButton.BackTop 
        visibilityHeight={100}
        icon={<VerticalAlignTopOutlined />}
        className="back-top-btn"
      />
    </Content>
  );
};

export default PostDetail;